/**
 * Centralized business / brand configuration for EC Design and Construction LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "EC Design and Construction LLC",
  shortName: "EC Design & Construction",
  legalName: "EC Design and Construction LLC",
  owner: "Abimael Cabrera Zuñiga",
  tagline: "Professional Remodeling & Construction Services in Clifton, NJ",
  description:
    "Remodeling and construction company based in Clifton, NJ serving Passaic County and northern New Jersey. Home remodeling, painting, masonry, roofing, retaining walls, pavers, flooring and new construction — Monday through Saturday.",

  // Live custom domain.
  domain: "ecdesignandconstructionllc.com",
  url: "https://ecdesignandconstructionllc.com",

  phone: "(973) 931-5980",
  phoneHref: "tel:+19739315980",

  email: "Ecdesignandconstruction@hotmail.com",
  emailHref: "mailto:Ecdesignandconstruction@hotmail.com",

  address: {
    city: "Clifton",
    state: "NJ",
    postalCode: "07011",
    region: "Passaic County",
  },

  hours: {
    summary: "Mon–Sat · 8 AM – 5 PM",
    days: "Monday – Saturday",
    time: "8:00 AM – 5:00 PM",
    closed: "Sunday",
  },

  languages: "English & Spanish",

  logo: "/ec-design-and-construction-logo.jpeg",
  /** Square center-crop of the logo mark — used for the browser tab icon. */
  favicon: "/ec-design-and-construction-icon.jpg",
  /** 1200×630 logo card for link previews. */
  ogImage: "/ec-design-and-construction-og.jpg",

  social: {
    instagram: "https://www.instagram.com/ecdesignandconstruction/",
    facebook: "https://www.facebook.com/share/1jLsgy2tGZ/?mibextid=wwXIfr",
    tiktok: "https://www.tiktok.com/@ec.design0",
  },

  discount: {
    label: "10% Referral Discount",
    short: "10% Referral Discount",
    description:
      "Refer a customer to EC Design and Construction LLC and receive 10% off your next qualifying project.",
  },

  /** EC Design and Construction's own LeadConnector / form widgets. */
  widgets: {
    chatWidgetId: "6a98432f47ecbaf9b3fb5362",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/9sMBWuOwENMoVTEZDzcb",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "9sMBWuOwENMoVTEZDzcb",
    formName: "Website Form",
    formHeight: "871",
  },

  serviceAreas: [
    "Clifton, NJ",
    "Passaic, NJ",
    "Paterson, NJ",
    "Wayne, NJ",
    "Garfield, NJ",
    "Fair Lawn, NJ",
    "Haledon, NJ",
    "Pompton Plains, NJ",
    "Midland Park, NJ",
    "Ridgewood, NJ",
    "Wallington, NJ",
    "Bloomfield, NJ",
    "Montclair, NJ",
    "Woodland Park, NJ",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
